"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
Recursively copy a value.

@param source - should be a JavaScript primitive, Array, or (plain old) Object.
@returns copy of source where every Array and Object have been recursively
         reconstructed from their constituent elements
*/

function clone(source) {
  // loose-equality checking for null is faster than strict checking for each of null/undefined/true/false
  // checking null first, then calling typeof, is faster than vice-versa
  if (source == null || typeof source != 'object') {
    // short-circuiting is faster than a single return
    return source;
  } // x.constructor == Array is the fastest way to check if x is an Array


  if (source.constructor == Array) {
    // construction via imperative for-loop is faster than source.map(arrayVsObject)
    var length_1 = source.length; // setting the Array length during construction is faster than just `[]` or `new Array()`

    var arrayTarget = new Array(length_1);

    for (var i = 0; i < length_1; i++) {
      arrayTarget[i] = clone(source[i]);
    }

    return arrayTarget;
  } // Object


  var objectTarget = {}; // declaring the variable (with const) inside the loop is faster

  for (var key in source) {
    // hasOwnProperty costs a bit of performance, but it's semantically necessary
    // using a global helper is MUCH faster than calling source.hasOwnProperty(key)
    if (hasOwnProperty.call(source, key)) {
      objectTarget[key] = clone(source[key]);
    }
  }

  return objectTarget;
}

exports.clone = clone;